@if (time$ | async; as time) {
    <div class="layout-footer">

        @if (showTrash()) {
            <app-button
                icon="pi-trash"
                [title]="'entities.trash.label' | translate"
                [text]="true"
                styleClass="trashIcon"
                (clickEvent)="openTrash()"
                severity="secondary"
            ></app-button>
        }

        <div class="footer-info">
            IS OMNIA @if (environment.deployVersion != '{{deploy_version}}') { {{ environment.deployVersion }} } © IT2GO s.r.o. 2021 - {{ time.getFullYear() }} |
            {{ 'footer.todayIs' | translate }} {{ time | localDate }}
        </div>

    </div>
}
